<template>
  <div class="tag-group">
    <div>{{currentTag.name}}</div>
    <div class="error-message">{{pageError}}</div>
    <loading-icon v-if="loading"></loading-icon>
    <div v-else>
      <div v-if="currentTag.status != 0" class="status">{{tagStatus}}</div>
      <div v-else class="button" @click="selectTag">this is me</div>
    </div>
  </div>
</template>

<script>
import { tagAPI } from '../../services/api/tagAPI'
import LoadingIcon from '../Shared/LoadingIcon'

export default {
  props: {
    tag: Object,
    advertiserId: [Number, String]
  },

  name: 'tag',

  components: {
    LoadingIcon
  },

  data() {
    return {
      loading: false,
      currentTag: null,
      pageError: null,
    }
  },

  computed: {
    tagStatus() {
      return this.currentTag.status === 'claimed' ? 'selected' : this.currentTag.status
    }
  },

  methods: {
    async selectTag() {
      try {
        const params = {
          brand_id: this.advertiserId,
          status: 'claimed',
          tags: [{ tag_id: this.tag.id, merchant_id: this.tag.merchant_id }]
        }
        this.loading = true
        const data = await tagAPI.updateTag(this.advertiserId, params)
        if (data) {
          this.$emit('refreshAllSections', 'retailers')
          this.currentTag.status = 'claimed'
        } else {
          this.pageError = 'there was an error updating tag, please refresh or contact support'
        }
      } catch(e) {
        this.pageError = `there was an issue updating tag: ${e}`
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.currentTag = this.tag
  },
 }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/colors'

  .tag-group
    display: flex
    justify-content: space-between
    padding: .5rem 2rem

    .status
      color: $title-color
      margin: 0 .35rem 0 0

  .loading-icon
    width: 20px
    margin: 0 1.5rem 0 0

  .button
    border: 1px solid $primary-color
    font-size: .9rem
    min-width: 60px
    padding: .075rem .15rem
    text-align: center
</style>
